export default function healthpass(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#292D32';
  const stroke = props?.strokeWidth ?? 1.5;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={s}
      height={s}
      viewBox="0 0 48 48"
      fill="none"
      stroke={c}
      strokeWidth={stroke}
    >
      <g clipPath="url(#a)">
        <mask
          id="b"
          width={48}
          height={42}
          x={0}
          y={3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <path fill="#fff" d="M47.919 3H.162v42H47.92V3Z" />
        </mask>
        <g mask="url(#b)">
          <mask
            id="c"
            width={208}
            height={118}
            x={0}
            y={-3}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'luminance',
            }}
          >
            <path fill="#fff" d="M207.73-2.676H.162v116.757H207.73V-2.676Z" />
          </mask>
          <g mask="url(#c)">
            <mask
              id="d"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#d)">
              <path
                fill="#B22224"
                d="M29.235 31.2c.462.444.25 1.203-.38 1.366-.63.162-1.208-.393-1.039-1 .17-.607.957-.81 1.42-.366Z"
              />
            </g>
            <mask
              id="e"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#e)">
              <path
                fill="#B22224"
                d="M26.599 32.851c.454.437.246 1.183-.374 1.343-.62.16-1.188-.386-1.022-.983.166-.597.942-.797 1.396-.36Z"
              />
            </g>
            <mask
              id="f"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#f)">
              <path
                fill="#B22224"
                d="M23.476 33.351c.431.415.234 1.124-.355 1.276-.59.152-1.129-.367-.971-.934.158-.567.894-.757 1.326-.342Z"
              />
            </g>
            <mask
              id="g"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#g)">
              <path
                fill="#B22224"
                d="M20.401 32.618c.394.379.214 1.026-.324 1.164-.537.139-1.03-.335-.885-.852.144-.517.816-.69 1.21-.312Z"
              />
            </g>
            <mask
              id="h"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#h)">
              <path
                fill="#B22224"
                d="M17.913 30.773a.614.614 0 0 1-.29 1.041c-.48.124-.92-.299-.791-.762.128-.462.73-.617 1.081-.279Z"
              />
            </g>
            <mask
              id="i"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#i)">
              <path
                fill="#B22224"
                d="M16.359 28.216c.25.24.135.65-.206.738-.341.088-.653-.212-.562-.54.091-.329.518-.439.768-.198Z"
              />
            </g>
            <mask
              id="j"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#j)">
              <path
                fill="#B22224"
                d="M25.598 19.324a.455.455 0 0 1-.215.772c-.357.092-.683-.222-.587-.565.095-.343.541-.458.802-.207Z"
              />
            </g>
            <mask
              id="k"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#k)">
              <path
                fill="#B22224"
                d="M28.44 20.71c.27.26.146.705-.224.8-.37.096-.707-.23-.608-.586.099-.355.56-.474.831-.214Z"
              />
            </g>
            <mask
              id="l"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#l)">
              <path
                fill="#B22224"
                d="M30.483 23.04a.428.428 0 0 1-.202.726c-.335.087-.642-.209-.552-.532.09-.322.509-.43.754-.194Z"
              />
            </g>
            <mask
              id="m"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#m)">
              <path
                fill="#B22224"
                d="M31.392 25.733c.43.415.234 1.124-.356 1.276-.589.152-1.128-.367-.97-.934.158-.567.894-.757 1.326-.342Z"
              />
            </g>
            <mask
              id="n"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#n)">
              <path
                fill="#B22224"
                d="M30.803 28.94c.454.437.247 1.183-.374 1.343-.62.16-1.188-.387-1.021-.983.166-.597.941-.797 1.395-.36Z"
              />
            </g>
            <mask
              id="o"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#o)">
              <path
                fill="#B22224"
                d="M24.213 36.316c0 .67-.753 1.088-1.355.754a.854.854 0 0 1 0-1.507c.602-.335 1.355.084 1.355.753Z"
              />
            </g>
            <mask
              id="p"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#p)">
              <path
                fill="#B22224"
                d="M21.103 35.843c0 .665-.747 1.08-1.345.748a.847.847 0 0 1 0-1.495c.598-.332 1.345.083 1.345.747Z"
              />
            </g>
            <mask
              id="q"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#q)">
              <path
                fill="#B22224"
                d="M18.269 34.47c0 .64-.719 1.038-1.293.72a.814.814 0 0 1 0-1.438c.574-.32 1.293.08 1.293.719Z"
              />
            </g>
            <mask
              id="r"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#r)">
              <path
                fill="#B22224"
                d="M15.998 32.333c0 .602-.677.979-1.22.677a.768.768 0 0 1 0-1.355c.543-.302 1.22.075 1.22.678Z"
              />
            </g>
            <mask
              id="s"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#s)">
              <path
                fill="#B22224"
                d="M14.502 29.638c0 .551-.62.896-1.115.62a.703.703 0 0 1 0-1.24c.495-.275 1.115.07 1.115.62Z"
              />
            </g>
            <mask
              id="t"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#t)">
              <path
                fill="#B22224"
                d="M13.934 26.652c0 .494-.556.803-1 .556a.63.63 0 0 1 0-1.112c.444-.247 1 .061 1 .556Z"
              />
            </g>
            <mask
              id="u"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#u)">
              <path
                fill="#B22224"
                d="M14.35 23.666c0 .437-.493.71-.887.492a.558.558 0 0 1 0-.985c.394-.219.886.055.886.493Z"
              />
            </g>
            <mask
              id="v"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#v)">
              <path
                fill="#B22224"
                d="M15.658 20.971c0 .35-.394.57-.71.394a.446.446 0 0 1 0-.788c.316-.175.71.044.71.394Z"
              />
            </g>
            <mask
              id="w"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#w)">
              <path
                fill="#B22224"
                d="M29.546 18.672c0 .124-.139.201-.25.14a.158.158 0 0 1 0-.279c.111-.062.25.016.25.14Z"
              />
            </g>
            <mask
              id="x"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#x)">
              <path
                fill="#B22224"
                d="M31.92 20.971c0 .36-.405.586-.73.406a.46.46 0 0 1 0-.811c.325-.18.73.045.73.405Z"
              />
            </g>
            <mask
              id="y"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#y)">
              <path
                fill="#B22224"
                d="M31.5 19.359c0 .36-.405.586-.73.405a.46.46 0 0 1 0-.81c.325-.18.73.044.73.405Z"
              />
            </g>
            <mask
              id="z"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#z)">
              <path
                fill="#B22224"
                d="M26.713 17.627c0 .36-.406.586-.73.406a.46.46 0 0 1 0-.811c.324-.18.73.045.73.405Z"
              />
            </g>
            <mask
              id="A"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#A)">
              <path
                fill="#B22224"
                d="M23.686 17.811c0 .361-.406.586-.73.406a.46.46 0 0 1 0-.811c.324-.18.73.045.73.405Z"
              />
            </g>
            <mask
              id="B"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#B)">
              <path
                fill="#B22224"
                d="M21.512 18.572c0 .36-.406.586-.73.405a.46.46 0 0 1 0-.81c.324-.18.73.044.73.405Z"
              />
            </g>
            <mask
              id="C"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#C)">
              <path
                fill="#B22224"
                d="M20.202 20.24c0 .361-.406.586-.73.406a.46.46 0 0 1 0-.811c.324-.18.73.045.73.405Z"
              />
            </g>
            <mask
              id="D"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#D)">
              <path
                fill="#B22224"
                d="M33.452 23.666c0 .437-.493.71-.887.492a.558.558 0 0 1 0-.985c.394-.219.887.055.887.493Z"
              />
            </g>
            <mask
              id="E"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#E)">
              <path
                fill="#B22224"
                d="M34.02 26.652c0 .494-.556.803-1.002.556a.63.63 0 0 1 0-1.112c.446-.247 1.002.061 1.002.556Z"
              />
            </g>
            <mask
              id="F"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#F)">
              <path
                fill="#B22224"
                d="M33.605 29.638c0 .551-.62.896-1.116.62a.703.703 0 0 1 0-1.24c.496-.275 1.116.07 1.116.62Z"
              />
            </g>
            <mask
              id="G"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#G)">
              <path
                fill="#B22224"
                d="M32.248 32.333c0 .602-.678.979-1.22.677a.768.768 0 0 1 0-1.355c.542-.302 1.22.075 1.22.678Z"
              />
            </g>
            <mask
              id="H"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#H)">
              <path
                fill="#B22224"
                d="M30.074 34.47c0 .64-.718 1.038-1.293.72a.814.814 0 0 1 0-1.438c.575-.32 1.293.08 1.293.719Z"
              />
            </g>
            <mask
              id="I"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#I)">
              <path
                fill="#B22224"
                d="M27.31 35.843c0 .665-.747 1.08-1.345.748a.847.847 0 0 1 0-1.495c.598-.332 1.345.083 1.345.747Z"
              />
            </g>
            <mask
              id="J"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#J)">
              <path
                fill="#B22224"
                d="M15.111 35.847c-.522.502-1.414.273-1.605-.414-.19-.686.462-1.314 1.175-1.13.714.183.953 1.041.43 1.544Z"
              />
            </g>
            <mask
              id="K"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#K)">
              <path
                fill="#B22224"
                d="M13.178 33.45c-.519.498-1.404.27-1.594-.411-.19-.682.459-1.306 1.167-1.123.708.183.945 1.034.427 1.534Z"
              />
            </g>
            <mask
              id="L"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#L)">
              <path
                fill="#B22224"
                d="M11.909 30.651c-.504.485-1.363.263-1.547-.399-.184-.661.445-1.267 1.132-1.09.688.178.918 1.005.415 1.49Z"
              />
            </g>
            <mask
              id="M"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#M)">
              <path
                fill="#B22224"
                d="M11.387 27.632c-.48.463-1.301.251-1.477-.38-.176-.633.425-1.21 1.081-1.041.656.17.876.959.396 1.421Z"
              />
            </g>
            <mask
              id="N"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#N)">
              <path
                fill="#B22224"
                d="M11.644 24.58c-.45.433-1.22.235-1.385-.357-.164-.592.399-1.134 1.014-.975.615.158.82.898.37 1.331Z"
              />
            </g>
            <mask
              id="O"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#O)">
              <path
                fill="#B22224"
                d="M12.665 21.688c-.416.4-1.127.217-1.28-.33-.152-.547.369-1.048.937-.901.57.146.76.83.343 1.23Z"
              />
            </g>
            <mask
              id="P"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#P)">
              <path
                fill="#B22224"
                d="M14.38 19.131c-.375.36-1.014.196-1.152-.297-.137-.492.332-.943.843-.81.512.131.684.747.309 1.107Z"
              />
            </g>
            <mask
              id="Q"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#Q)">
              <path
                fill="#B22224"
                d="M16.686 17.077c-.333.32-.901.173-1.023-.264-.122-.438.294-.838.749-.721a.58.58 0 0 1 .274.985Z"
              />
            </g>
            <mask
              id="R"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#R)">
              <path
                fill="#B22224"
                d="M19.436 15.65c-.291.28-.789.152-.896-.231-.106-.383.258-.734.656-.631a.508.508 0 0 1 .24.862Z"
              />
            </g>
            <mask
              id="S"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#S)">
              <path
                fill="#B22224"
                d="M22.457 14.942c-.253.244-.686.132-.779-.201-.092-.333.224-.638.57-.549.347.09.463.506.21.75Z"
              />
            </g>
            <mask
              id="T"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#T)">
              <path
                fill="#B22224"
                d="M25.41 14.852c-.105.102-.286.056-.325-.084-.038-.139.094-.266.239-.229a.185.185 0 0 1 .087.313Z"
              />
            </g>
            <mask
              id="U"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#U)">
              <path
                fill="#B22224"
                d="M35.86 24.909c-.117.113-.317.06-.36-.093-.043-.154.104-.295.264-.254.16.041.214.234.097.347Z"
              />
            </g>
            <mask
              id="V"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#V)">
              <path
                fill="#B22224"
                d="M33.11 20.71c-.118.112-.318.06-.361-.094-.043-.154.104-.295.264-.253.16.04.214.233.097.346Z"
              />
            </g>
            <mask
              id="W"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#W)">
              <path
                fill="#B22224"
                d="M36.136 28.106c-.253.244-.686.132-.779-.201-.093-.334.224-.638.57-.55.347.09.463.507.21.75Z"
              />
            </g>
            <mask
              id="X"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#X)">
              <path
                fill="#B22224"
                d="M35.5 31.108c-.292.28-.79.152-.896-.23-.107-.384.257-.734.655-.631a.508.508 0 0 1 .24.861Z"
              />
            </g>
            <mask
              id="Y"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#Y)">
              <path
                fill="#B22224"
                d="M34.125 33.858c-.333.32-.902.174-1.024-.263-.122-.438.295-.839.75-.721a.58.58 0 0 1 .274.984Z"
              />
            </g>
            <mask
              id="Z"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#Z)">
              <path
                fill="#B22224"
                d="M32.098 36.182c-.375.36-1.014.195-1.152-.297-.137-.492.332-.943.843-.811.512.132.683.747.309 1.108Z"
              />
            </g>
            <mask
              id="aa"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aa)">
              <path
                fill="#B22224"
                d="M29.55 37.936c-.417.4-1.128.218-1.28-.33-.152-.547.368-1.047.937-.9.568.146.759.83.342 1.23Z"
              />
            </g>
            <mask
              id="ab"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ab)">
              <path
                fill="#B22224"
                d="M26.633 39.004c-.45.434-1.22.236-1.384-.356-.165-.593.398-1.134 1.013-.976.615.16.821.9.37 1.332Z"
              />
            </g>
            <mask
              id="ac"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ac)">
              <path
                fill="#B22224"
                d="M23.54 39.327c-.481.463-1.302.251-1.478-.38-.175-.632.425-1.21 1.082-1.041.656.17.876.959.396 1.421Z"
              />
            </g>
            <mask
              id="ad"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ad)">
              <path
                fill="#B22224"
                d="M20.461 38.882c-.503.484-1.362.263-1.547-.399-.184-.661.445-1.267 1.133-1.09.687.178.917 1.005.414 1.489Z"
              />
            </g>
            <mask
              id="ae"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ae)">
              <path
                fill="#B22224"
                d="M17.593 37.698c-.519.5-1.404.27-1.594-.41-.19-.682.459-1.306 1.167-1.123.708.182.945 1.034.427 1.533Z"
              />
            </g>
            <mask
              id="af"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#af)">
              <path
                fill="#B22224"
                d="M8.246 27.629c-.782 0-1.27-.814-.88-1.466.391-.65 1.368-.65 1.759 0 .39.652-.098 1.466-.88 1.466Z"
              />
            </g>
            <mask
              id="ag"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ag)">
              <path
                fill="#B22224"
                d="M8.575 24.608c-.776 0-1.261-.808-.873-1.455.388-.647 1.358-.647 1.746 0 .388.647-.097 1.455-.873 1.455Z"
              />
            </g>
            <mask
              id="ah"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ah)">
              <path
                fill="#B22224"
                d="M9.548 21.706c-.76 0-1.235-.792-.855-1.425.38-.634 1.33-.634 1.71 0 .38.633-.095 1.425-.855 1.425Z"
              />
            </g>
            <mask
              id="ai"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ai)">
              <path
                fill="#B22224"
                d="M11.123 19.047c-.733 0-1.192-.763-.825-1.374.366-.611 1.283-.611 1.65 0 .366.61-.092 1.375-.825 1.375Z"
              />
            </g>
            <mask
              id="aj"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aj)">
              <path
                fill="#B22224"
                d="M13.23 16.748c-.696 0-1.13-.724-.783-1.304.348-.58 1.218-.58 1.566 0 .347.58-.087 1.304-.783 1.304Z"
              />
            </g>
            <mask
              id="ak"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ak)">
              <path
                fill="#B22224"
                d="M15.778 14.914c-.653 0-1.061-.68-.735-1.225.327-.544 1.143-.544 1.469 0 .326.544-.082 1.225-.734 1.225Z"
              />
            </g>
            <mask
              id="al"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#al)">
              <path
                fill="#B22224"
                d="M18.654 13.62c-.604 0-.982-.63-.68-1.133a.801.801 0 0 1 1.36 0c.303.504-.075 1.134-.68 1.134Z"
              />
            </g>
            <mask
              id="am"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#am)">
              <path
                fill="#B22224"
                d="M21.735 12.917c-.546 0-.887-.569-.614-1.024a.723.723 0 0 1 1.228 0c.273.455-.068 1.024-.614 1.024Z"
              />
            </g>
            <mask
              id="an"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#an)">
              <path
                fill="#B22224"
                d="M24.884 12.837c-.482 0-.782-.502-.542-.903a.638.638 0 0 1 1.084 0c.24.401-.06.903-.542.903Z"
              />
            </g>
            <mask
              id="ao"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ao)">
              <path
                fill="#B22224"
                d="M27.965 13.393c-.423 0-.688-.44-.476-.793a.56.56 0 0 1 .951 0c.211.353-.053.793-.475.793Z"
              />
            </g>
            <mask
              id="ap"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ap)">
              <path
                fill="#B22224"
                d="M30.911 14.559c-.423 0-.687-.44-.476-.793a.56.56 0 0 1 .952 0c.212.352-.053.793-.476.793Z"
              />
            </g>
            <mask
              id="aq"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aq)">
              <path
                fill="#B22224"
                d="M33.692 16.525c-.423 0-.688-.441-.476-.794a.56.56 0 0 1 .952 0c.212.353-.053.794-.476.794Z"
              />
            </g>
            <mask
              id="ar"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ar)">
              <path
                fill="#B22224"
                d="M35.807 18.744c-.433 0-.704-.451-.487-.812a.574.574 0 0 1 .974 0c.217.36-.054.812-.487.812Z"
              />
            </g>
            <mask
              id="as"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#as)">
              <path
                fill="#B22224"
                d="M35.496 35.434c-.208 0-.339-.218-.234-.392a.277.277 0 0 1 .47 0c.104.174-.027.392-.236.392Z"
              />
            </g>
            <mask
              id="at"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#at)">
              <path
                fill="#B22224"
                d="M33.39 37.826c-.322 0-.523-.334-.362-.602a.425.425 0 0 1 .722 0c.161.268-.04.602-.36.602Z"
              />
            </g>
            <mask
              id="au"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#au)">
              <path
                fill="#B22224"
                d="M30.842 39.668c-.37 0-.6-.385-.416-.692a.49.49 0 0 1 .831 0c.185.307-.046.692-.415.692Z"
              />
            </g>
            <mask
              id="av"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#av)">
              <path
                fill="#B22224"
                d="M27.965 40.968c-.423 0-.688-.44-.476-.793a.56.56 0 0 1 .951 0c.212.352-.053.793-.475.793Z"
              />
            </g>
            <mask
              id="aw"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aw)">
              <path
                fill="#B22224"
                d="M24.884 41.671c-.482 0-.782-.502-.542-.903a.638.638 0 0 1 1.084 0c.24.401-.06.903-.542.903Z"
              />
            </g>
            <mask
              id="ax"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ax)">
              <path
                fill="#B22224"
                d="M21.735 41.752c-.546 0-.887-.57-.614-1.024a.723.723 0 0 1 1.228 0c.273.455-.068 1.024-.614 1.024Z"
              />
            </g>
            <mask
              id="ay"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ay)">
              <path
                fill="#B22224"
                d="M18.654 41.195c-.604 0-.982-.63-.68-1.134a.801.801 0 0 1 1.36 0c.303.504-.075 1.134-.68 1.134Z"
              />
            </g>
            <mask
              id="az"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#az)">
              <path
                fill="#B22224"
                d="M15.778 40.023c-.653 0-1.061-.68-.735-1.225.327-.544 1.143-.544 1.469 0 .326.544-.082 1.225-.734 1.225Z"
              />
            </g>
            <mask
              id="aA"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aA)">
              <path
                fill="#B22224"
                d="M13.23 38.295c-.696 0-1.13-.725-.783-1.305.348-.58 1.218-.58 1.566 0 .347.58-.087 1.305-.783 1.305Z"
              />
            </g>
            <mask
              id="aB"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aB)">
              <path
                fill="#B22224"
                d="M11.123 36.09c-.734 0-1.192-.764-.825-1.375.366-.611 1.283-.611 1.65 0 .366.61-.092 1.374-.825 1.374Z"
              />
            </g>
            <mask
              id="aC"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aC)">
              <path
                fill="#B22224"
                d="M9.548 33.498c-.76 0-1.235-.791-.855-1.425.38-.633 1.33-.633 1.71 0 .38.633-.095 1.425-.855 1.425Z"
              />
            </g>
            <mask
              id="aD"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aD)">
              <path
                fill="#B22224"
                d="M8.575 30.636c-.776 0-1.261-.808-.873-1.455.388-.647 1.358-.647 1.746 0 .388.647-.097 1.455-.873 1.455Z"
              />
            </g>
            <mask
              id="aE"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aE)">
              <path
                fill="#B22224"
                d="M10.126 15.421c-.583-.56-.317-1.518.48-1.723.795-.206 1.524.495 1.31 1.261-.213.767-1.208 1.023-1.79.462Z"
              />
            </g>
            <mask
              id="aF"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aF)">
              <path
                fill="#B22224"
                d="M12.55 13.473c-.58-.557-.315-1.508.476-1.712.79-.204 1.514.492 1.303 1.254-.212.76-1.201 1.016-1.78.458Z"
              />
            </g>
            <mask
              id="aG"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aG)">
              <path
                fill="#B22224"
                d="M15.3 11.967c-.572-.55-.31-1.488.47-1.69.78-.2 1.495.487 1.285 1.238-.209.75-1.184 1.002-1.756.452Z"
              />
            </g>
            <mask
              id="aH"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aH)">
              <path
                fill="#B22224"
                d="M18.298 10.942c-.553-.531-.3-1.439.455-1.634.754-.194 1.445.47 1.243 1.197-.202.726-1.146.97-1.698.437Z"
              />
            </g>
            <mask
              id="aI"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aI)">
              <path
                fill="#B22224"
                d="M21.44 10.44c-.53-.51-.288-1.38.436-1.567.723-.187 1.385.45 1.191 1.147-.194.696-1.098.93-1.628.42Z"
              />
            </g>
            <mask
              id="aJ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aJ)">
              <path
                fill="#B22224"
                d="M24.623 10.475c-.503-.485-.272-1.312.415-1.489.688-.177 1.317.428 1.132 1.09-.184.661-1.043.883-1.547.399Z"
              />
            </g>
            <mask
              id="aK"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aK)">
              <path
                fill="#B22224"
                d="M27.75 11.045c-.473-.455-.257-1.232.39-1.4.645-.166 1.236.403 1.063 1.025-.173.622-.98.83-1.453.375Z"
              />
            </g>
            <mask
              id="aL"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aL)">
              <path
                fill="#B22224"
                d="M30.723 12.127c-.435-.42-.236-1.134.358-1.288.595-.153 1.139.37.98.943-.16.572-.903.763-1.338.345Z"
              />
            </g>
            <mask
              id="aM"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aM)">
              <path
                fill="#B22224"
                d="M33.445 13.688c-.394-.38-.214-1.026.324-1.164.538-.139 1.03.334.885.852-.144.517-.816.69-1.21.312Z"
              />
            </g>
            <mask
              id="aN"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aN)">
              <path
                fill="#B22224"
                d="M35.825 15.681a.614.614 0 0 1 .29-1.04c.48-.125.92.299.791.761-.129.463-.73.618-1.081.28Z"
              />
            </g>
            <mask
              id="aO"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aO)">
              <path
                fill="#B22224"
                d="M37.787 18.042a.541.541 0 0 1 .256-.918c.424-.11.812.264.698.672-.114.408-.643.544-.954.246Z"
              />
            </g>
            <mask
              id="aP"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aP)">
              <path
                fill="#B22224"
                d="M39.272 20.574a.469.469 0 0 1 .221-.795c.367-.094.703.229.604.582-.098.353-.557.472-.825.213Z"
              />
            </g>
            <mask
              id="aQ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aQ)">
              <path
                fill="#B22224"
                d="M36.702 21.197a.469.469 0 0 1 .221-.795c.367-.095.703.228.605.582-.099.353-.558.471-.826.212Z"
              />
            </g>
            <mask
              id="aR"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aR)">
              <path
                fill="#B22224"
                d="M40.227 23.577a.403.403 0 0 1 .19-.683c.316-.081.604.196.52.5-.085.303-.48.405-.71.183Z"
              />
            </g>
            <mask
              id="aS"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aS)">
              <path
                fill="#B22224"
                d="M37.887 23.577a.403.403 0 0 1 .19-.683c.315-.081.604.196.52.5-.085.303-.48.405-.71.183Z"
              />
            </g>
            <mask
              id="aT"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aT)">
              <path
                fill="#B22224"
                d="M29.04 42.687a.1.1 0 0 1 .047-.168c.078-.02.149.048.128.123-.02.074-.118.1-.175.045Z"
              />
            </g>
            <mask
              id="aU"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aU)">
              <path
                fill="#B22224"
                d="M25.848 43.56a.284.284 0 0 1 .134-.481c.222-.058.425.138.366.352-.06.214-.338.285-.5.129Z"
              />
            </g>
            <mask
              id="aV"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aV)">
              <path
                fill="#B22224"
                d="M22.655 43.811a.35.35 0 0 1 .165-.593c.274-.07.525.17.451.434-.073.264-.416.352-.616.16Z"
              />
            </g>
            <mask
              id="aW"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aW)">
              <path
                fill="#B22224"
                d="M19.484 43.51a.403.403 0 0 1 .19-.683c.316-.081.604.196.52.5-.085.303-.479.405-.71.183Z"
              />
            </g>
            <mask
              id="aX"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aX)">
              <path
                fill="#B22224"
                d="M16.418 42.685a.469.469 0 0 1 .221-.795c.367-.095.703.229.605.582-.099.353-.558.471-.826.213Z"
              />
            </g>
            <mask
              id="aY"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aY)">
              <path
                fill="#B22224"
                d="M13.556 41.36a.541.541 0 0 1 .256-.917c.424-.11.812.263.698.671-.114.408-.643.545-.954.246Z"
              />
            </g>
            <mask
              id="aZ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#aZ)">
              <path
                fill="#B22224"
                d="M10.995 39.575a.614.614 0 0 1 .29-1.04c.48-.124.92.299.792.762-.129.462-.73.617-1.082.279Z"
              />
            </g>
            <mask
              id="ba"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ba)">
              <path
                fill="#B22224"
                d="M8.816 37.39c-.394-.38-.214-1.026.324-1.165.537-.138 1.03.335.885.853-.144.517-.816.69-1.21.311Z"
              />
            </g>
            <mask
              id="bb"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bb)">
              <path
                fill="#B22224"
                d="M7.085 34.874c-.435-.419-.236-1.134.359-1.287.594-.153 1.138.37.979.942-.16.572-.903.764-1.338.345Z"
              />
            </g>
            <mask
              id="bc"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bc)">
              <path
                fill="#B22224"
                d="M5.863 32.107c-.473-.455-.256-1.232.39-1.399.646-.166 1.237.403 1.064 1.024-.173.622-.981.83-1.454.375Z"
              />
            </g>
            <mask
              id="bd"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bd)">
              <path
                fill="#B22224"
                d="M5.192 29.175c-.503-.485-.273-1.312.414-1.489.688-.177 1.317.428 1.133 1.09-.185.661-1.044.883-1.547.399Z"
              />
            </g>
            <mask
              id="be"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#be)">
              <path
                fill="#B22224"
                d="M5.087 26.177c-.53-.51-.288-1.38.436-1.567.724-.187 1.386.45 1.192 1.147-.194.696-1.099.93-1.628.42Z"
              />
            </g>
            <mask
              id="bf"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bf)">
              <path
                fill="#B22224"
                d="M5.55 23.21c-.552-.532-.3-1.44.455-1.634.755-.195 1.445.47 1.243 1.196-.202.727-1.146.97-1.698.438Z"
              />
            </g>
            <mask
              id="bg"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bg)">
              <path
                fill="#B22224"
                d="M6.566 20.372c-.571-.55-.31-1.489.47-1.69.781-.202 1.495.486 1.286 1.237-.209.751-1.185 1.003-1.756.453Z"
              />
            </g>
            <mask
              id="bh"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bh)">
              <path
                fill="#B22224"
                d="M8.111 17.744c-.579-.557-.314-1.509.477-1.712.79-.204 1.514.492 1.303 1.253-.212.761-1.201 1.016-1.78.46Z"
              />
            </g>
            <mask
              id="bi"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bi)">
              <path
                fill="#B22224"
                d="M22.183 7.323c0-.834.939-1.356 1.69-.939.75.418.75 1.46 0 1.878-.751.417-1.69-.105-1.69-.94Z"
              />
            </g>
            <mask
              id="bj"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bj)">
              <path
                fill="#B22224"
                d="M25.332 7.561c0-.83.933-1.347 1.68-.933.745.415.745 1.451 0 1.866-.747.414-1.68-.104-1.68-.933Z"
              />
            </g>
            <mask
              id="bk"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bk)">
              <path
                fill="#B22224"
                d="M28.411 8.269c0-.819.921-1.33 1.658-.921.737.41.737 1.433 0 1.842-.737.41-1.658-.102-1.658-.921Z"
              />
            </g>
            <mask
              id="bl"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bl)">
              <path
                fill="#B22224"
                d="M31.35 9.43c0-.798.899-1.297 1.617-.898a1.018 1.018 0 0 1 0 1.796c-.718.399-1.616-.1-1.616-.898Z"
              />
            </g>
            <mask
              id="bm"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bm)">
              <path
                fill="#B22224"
                d="M34.073 11.014c0-.772.869-1.255 1.564-.869a.985.985 0 0 1 0 1.739c-.695.386-1.564-.097-1.564-.87Z"
              />
            </g>
            <mask
              id="bn"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bn)">
              <path
                fill="#B22224"
                d="M36.518 12.984c0-.736.828-1.196 1.491-.828a.939.939 0 0 1 0 1.657c-.663.368-1.491-.092-1.491-.829Z"
              />
            </g>
            <mask
              id="bo"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bo)">
              <path
                fill="#B22224"
                d="M38.613 15.29c0-.7.788-1.138 1.419-.787a.893.893 0 0 1 0 1.575c-.63.35-1.419-.087-1.419-.787Z"
              />
            </g>
            <mask
              id="bp"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bp)">
              <path
                fill="#B22224"
                d="M40.069 17.627c0-.654.735-1.063 1.324-.736a.834.834 0 0 1 0 1.472c-.589.327-1.324-.082-1.324-.736Z"
              />
            </g>
            <mask
              id="bq"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bq)">
              <path
                fill="#B22224"
                d="M41.598 19.93c0-.603.678-.98 1.22-.678a.768.768 0 0 1 0 1.356c-.542.3-1.22-.076-1.22-.678Z"
              />
            </g>
            <mask
              id="br"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#br)">
              <path
                fill="#B22224"
                d="M42.329 22.98c0-.551.62-.896 1.115-.62a.703.703 0 0 1 0 1.24c-.495.275-1.115-.07-1.115-.62Z"
              />
            </g>
            <mask
              id="bs"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bs)">
              <path
                fill="#B22224"
                d="M14.045 43.874c0-.108.122-.176.219-.122a.138.138 0 0 1 0 .244c-.097.054-.219-.014-.219-.122Z"
              />
            </g>
            <mask
              id="bt"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bt)">
              <path
                fill="#B22224"
                d="M11.24 42.29c0-.196.22-.319.396-.22a.25.25 0 0 1 0 .44c-.176.097-.396-.025-.396-.22Z"
              />
            </g>
            <mask
              id="bu"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bu)">
              <path
                fill="#B22224"
                d="M8.794 40.32c0-.232.261-.377.47-.261a.295.295 0 0 1 0 .521c-.209.116-.47-.029-.47-.26Z"
              />
            </g>
            <mask
              id="bv"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bv)">
              <path
                fill="#B22224"
                d="M6.685 38.013c0-.278.313-.452.563-.313.25.14.25.487 0 .626-.25.14-.563-.035-.563-.313Z"
              />
            </g>
            <mask
              id="bw"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bw)">
              <path
                fill="#B22224"
                d="M4.976 35.427c0-.324.365-.527.657-.365a.414.414 0 0 1 0 .73c-.292.162-.657-.04-.657-.365Z"
              />
            </g>
            <mask
              id="bx"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bx)">
              <path
                fill="#B22224"
                d="M3.693 32.625c0-.381.429-.62.772-.429a.486.486 0 0 1 0 .858c-.343.19-.772-.048-.772-.43Z"
              />
            </g>
            <mask
              id="by"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#by)">
              <path
                fill="#B22224"
                d="M2.88 29.675c0-.437.493-.71.887-.492a.558.558 0 0 1 0 .985c-.394.219-.886-.055-.886-.492Z"
              />
            </g>
            <mask
              id="bz"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bz)">
              <path
                fill="#B22224"
                d="M2.557 26.652c0-.495.556-.803 1.001-.556a.63.63 0 0 1 0 1.112c-.445.247-1.001-.062-1.001-.556Z"
              />
            </g>
            <mask
              id="bA"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bA)">
              <path
                fill="#B22224"
                d="M2.728 23.628c0-.55.62-.895 1.115-.62a.703.703 0 0 1 0 1.24c-.495.276-1.115-.069-1.115-.62Z"
              />
            </g>
            <mask
              id="bB"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bB)">
              <path
                fill="#B22224"
                d="M3.394 20.679c0-.602.678-.98 1.22-.678a.768.768 0 0 1 0 1.356c-.542.301-1.22-.076-1.22-.678Z"
              />
            </g>
            <mask
              id="bC"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bC)">
              <path
                fill="#B22224"
                d="M4.53 17.877c0-.654.736-1.063 1.325-.736a.834.834 0 0 1 0 1.472c-.589.327-1.324-.082-1.324-.736Z"
              />
            </g>
            <mask
              id="bD"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bD)">
              <path
                fill="#B22224"
                d="M6.115 15.29c0-.7.788-1.137 1.418-.787a.893.893 0 0 1 0 1.575c-.63.35-1.418-.087-1.418-.787Z"
              />
            </g>
            <mask
              id="bE"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bE)">
              <path
                fill="#B22224"
                d="M8.113 12.984c0-.736.828-1.197 1.491-.828a.939.939 0 0 1 0 1.657c-.663.368-1.491-.092-1.491-.829Z"
              />
            </g>
            <mask
              id="bF"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bF)">
              <path
                fill="#B22224"
                d="M10.461 11.014c0-.772.869-1.255 1.564-.869a.985.985 0 0 1 0 1.739c-.695.386-1.564-.097-1.564-.87Z"
              />
            </g>
            <mask
              id="bG"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bG)">
              <path
                fill="#B22224"
                d="M13.114 9.43c0-.799.897-1.297 1.616-.898.718.399.718 1.397 0 1.796-.719.399-1.617-.1-1.617-.898Z"
              />
            </g>
            <mask
              id="bH"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bH)">
              <path
                fill="#B22224"
                d="M15.998 8.269c0-.819.92-1.33 1.658-.921.736.41.736 1.433 0 1.842-.737.41-1.658-.102-1.658-.921Z"
              />
            </g>
            <mask
              id="bI"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bI)">
              <path
                fill="#B22224"
                d="M19.048 7.561c0-.83.933-1.347 1.68-.933.745.415.745 1.451 0 1.866-.747.414-1.68-.104-1.68-.933Z"
              />
            </g>
            <mask
              id="bJ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bJ)">
              <path
                fill="#B22224"
                d="M38.958 10.202c.64-.616 1.732-.334 1.966.507.234.84-.566 1.61-1.439 1.384-.874-.225-1.166-1.276-.527-1.891Z"
              />
            </g>
            <mask
              id="bK"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bK)">
              <path
                fill="#B22224"
                d="M41.031 12.496c.636-.612 1.722-.332 1.954.504.233.836-.562 1.6-1.43 1.377-.868-.224-1.16-1.269-.524-1.88Z"
              />
            </g>
            <mask
              id="bL"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bL)">
              <path
                fill="#B22224"
                d="M43.252 15.22c.628-.604 1.7-.328 1.93.498.23.826-.555 1.581-1.413 1.36-.858-.221-1.145-1.253-.517-1.858Z"
              />
            </g>
            <mask
              id="bM"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bM)">
              <path
                fill="#B22224"
                d="M44.875 18.576c.617-.593 1.67-.322 1.896.49.225.81-.546 1.552-1.388 1.335-.843-.217-1.125-1.231-.508-1.825Z"
              />
            </g>
            <mask
              id="bN"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bN)">
              <path
                fill="#B22224"
                d="M45.548 21.654c.601-.579 1.629-.314 1.849.477.22.791-.532 1.515-1.354 1.303-.822-.212-1.097-1.2-.495-1.78Z"
              />
            </g>
            <mask
              id="bO"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bO)">
              <path
                fill="#B22224"
                d="M1.583 32.896c.09-.087.246-.047.28.072.032.12-.081.228-.205.197a.158.158 0 0 1-.075-.269Z"
              />
            </g>
            <mask
              id="bP"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bP)">
              <path
                fill="#B22224"
                d="M.835 29.902c.12-.116.327-.063.372.096.044.16-.107.305-.273.262a.211.211 0 0 1-.1-.358Z"
              />
            </g>
            <mask
              id="bQ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bQ)">
              <path
                fill="#B22224"
                d="M.53 26.852c.144-.139.39-.075.442.114.053.189-.127.362-.323.311a.25.25 0 0 1-.119-.425Z"
              />
            </g>
            <mask
              id="bR"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bR)">
              <path
                fill="#B22224"
                d="M.656 23.784c.174-.167.471-.09.535.138.064.23-.154.438-.392.377a.304.304 0 0 1-.143-.515Z"
              />
            </g>
            <mask
              id="bS"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bS)">
              <path
                fill="#B22224"
                d="M1.208 20.759c.212-.204.574-.11.652.168.077.279-.188.533-.477.459a.37.37 0 0 1-.175-.627Z"
              />
            </g>
            <mask
              id="bT"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bT)">
              <path
                fill="#B22224"
                d="M2.186 17.843c.25-.24.676-.13.767.198.092.328-.22.629-.562.54a.436.436 0 0 1-.205-.738Z"
              />
            </g>
            <mask
              id="bU"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bU)">
              <path
                fill="#B22224"
                d="M3.568 15.093c.287-.277.778-.15.883.228.106.378-.254.724-.647.623a.502.502 0 0 1-.236-.851Z"
              />
            </g>
            <mask
              id="bV"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bV)">
              <path
                fill="#B22224"
                d="M5.317 12.551c.333-.32.901-.174 1.023.264.122.438-.294.838-.749.721a.58.58 0 0 1-.274-.985Z"
              />
            </g>
            <mask
              id="bW"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bW)">
              <path
                fill="#B22224"
                d="M7.413 10.28c.374-.36 1.014-.195 1.15.297.138.493-.33.943-.842.811-.512-.132-.683-.747-.308-1.108Z"
              />
            </g>
            <mask
              id="bX"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bX)">
              <path
                fill="#B22224"
                d="M9.808 8.32c.417-.401 1.127-.218 1.28.329.152.547-.368 1.048-.937.901-.568-.146-.759-.83-.343-1.23Z"
              />
            </g>
            <mask
              id="bY"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bY)">
              <path
                fill="#B22224"
                d="M12.461 6.71c.454-.438 1.23-.238 1.396.36.166.596-.401 1.142-1.022.982-.62-.16-.828-.906-.374-1.343Z"
              />
            </g>
            <mask
              id="bZ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#bZ)">
              <path
                fill="#B22224"
                d="M15.314 5.477c.492-.474 1.332-.257 1.512.39.18.646-.435 1.238-1.107 1.065-.672-.174-.897-.982-.405-1.455Z"
              />
            </g>
            <mask
              id="ca"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ca)">
              <path
                fill="#B22224"
                d="M18.203 4.332c.523-.502 1.414-.272 1.605.414.191.687-.461 1.315-1.175 1.131-.713-.184-.952-1.042-.43-1.545Z"
              />
            </g>
            <mask
              id="cb"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cb)">
              <path
                fill="#B22224"
                d="M21.41 3.692c.552-.532 1.495-.289 1.697.438.203.726-.488 1.39-1.243 1.196-.754-.195-1.007-1.103-.455-1.634Z"
              />
            </g>
            <mask
              id="cc"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cc)">
              <path
                fill="#B22224"
                d="M24.643 3.659c.58-.558 1.568-.303 1.78.458.212.761-.512 1.458-1.303 1.254-.79-.204-1.056-1.155-.477-1.712Z"
              />
            </g>
            <mask
              id="cd"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cd)">
              <path
                fill="#B22224"
                d="M28.113 4.438c.601-.58 1.629-.314 1.849.476.22.791-.532 1.515-1.354 1.303-.822-.212-1.097-1.2-.495-1.78Z"
              />
            </g>
            <mask
              id="ce"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ce)">
              <path
                fill="#B22224"
                d="M31.108 5.306c.616-.594 1.67-.322 1.896.488.225.811-.546 1.553-1.388 1.336-.843-.217-1.125-1.23-.508-1.824Z"
              />
            </g>
            <mask
              id="cf"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cf)">
              <path
                fill="#B22224"
                d="M33.95 6.574c.628-.605 1.7-.328 1.93.497.23.826-.555 1.582-1.413 1.36-.858-.22-1.145-1.253-.517-1.857Z"
              />
            </g>
            <mask
              id="cg"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cg)">
              <path
                fill="#B22224"
                d="M36.584 8.216c.636-.611 1.721-.332 1.954.504.233.836-.562 1.6-1.43 1.377-.869-.224-1.16-1.269-.524-1.88Z"
              />
            </g>
            <mask
              id="ch"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ch)">
              <path
                fill="#B22224"
                d="M19.085 26.137a.095.095 0 0 1-.121-.05.089.089 0 0 1 .05-.117.095.095 0 0 1 .122.05.089.089 0 0 1-.05.117Z"
              />
            </g>
            <mask
              id="ci"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ci)">
              <path
                fill="#B22224"
                d="M18.422 26.009a.095.095 0 0 1-.121-.05.089.089 0 0 1 .05-.117.095.095 0 0 1 .122.05.089.089 0 0 1-.05.117Z"
              />
            </g>
            <mask
              id="cj"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cj)">
              <path
                fill="#B22224"
                d="M18.398 25.43a.139.139 0 0 1-.178-.072.13.13 0 0 1 .074-.171c.07-.028.15.004.179.072a.13.13 0 0 1-.075.171Z"
              />
            </g>
            <mask
              id="ck"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ck)">
              <path
                fill="#B22224"
                d="M18.37 24.726a.204.204 0 0 1-.263-.106.191.191 0 0 1 .11-.253c.103-.04.22.006.263.106a.192.192 0 0 1-.11.253Z"
              />
            </g>
            <mask
              id="cl"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cl)">
              <path
                fill="#B22224"
                d="M18.37 23.954a.204.204 0 0 1-.263-.106.192.192 0 0 1 .11-.253c.103-.04.22.007.263.106a.192.192 0 0 1-.11.253Z"
              />
            </g>
            <mask
              id="cm"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cm)">
              <path
                fill="#B22224"
                d="M18.624 23.168a.204.204 0 0 1-.263-.106.192.192 0 0 1 .11-.253c.103-.04.221.007.263.106a.191.191 0 0 1-.11.253Z"
              />
            </g>
            <mask
              id="cn"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cn)">
              <path
                fill="#B22224"
                d="M19.583 25.583a.085.085 0 0 1-.11-.044.08.08 0 0 1 .047-.106.085.085 0 0 1 .11.045.08.08 0 0 1-.047.105Z"
              />
            </g>
            <mask
              id="co"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#co)">
              <path
                fill="#B22224"
                d="M19.63 26.18a.085.085 0 0 1-.11-.043.08.08 0 0 1 .046-.106.085.085 0 0 1 .11.044.08.08 0 0 1-.047.106Z"
              />
            </g>
            <mask
              id="cp"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cp)">
              <path
                fill="#B22224"
                d="M20.596 24.732a.066.066 0 0 1-.085-.035.062.062 0 0 1 .035-.082.066.066 0 0 1 .085.035.062.062 0 0 1-.035.082Z"
              />
            </g>
            <mask
              id="cq"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cq)">
              <path
                fill="#B22224"
                d="M21.2 24.447a.057.057 0 0 1-.073-.03.053.053 0 0 1 .03-.07.057.057 0 0 1 .073.03.053.053 0 0 1-.03.07Z"
              />
            </g>
            <mask
              id="cr"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cr)">
              <path
                fill="#B22224"
                d="M21.844 24.268a.047.047 0 0 1-.06-.025.044.044 0 0 1 .025-.058.048.048 0 0 1 .06.024.044.044 0 0 1-.025.059Z"
              />
            </g>
            <mask
              id="cs"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cs)">
              <path
                fill="#B22224"
                d="M22.51 24.2a.038.038 0 0 1-.049-.02.036.036 0 0 1 .02-.047c.02-.008.041.001.05.02a.035.035 0 0 1-.021.046Z"
              />
            </g>
            <mask
              id="ct"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ct)">
              <path
                fill="#B22224"
                d="M23.176 24.243a.028.028 0 0 1-.037-.014.027.027 0 0 1 .016-.036.028.028 0 0 1 .036.015c.006.014 0 .03-.015.035Z"
              />
            </g>
            <mask
              id="cu"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cu)">
              <path
                fill="#B22224"
                d="M23.823 24.398c-.01.004-.021 0-.025-.01-.004-.009 0-.02.01-.023.01-.004.02 0 .025.01.004.009-.001.02-.01.023Z"
              />
            </g>
            <mask
              id="cv"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cv)">
              <path
                fill="#B22224"
                d="M24.43 24.66a.01.01 0 0 1-.013-.005.009.009 0 0 1 .005-.011.01.01 0 0 1 .012.005c.002.004 0 .01-.005.011Z"
              />
            </g>
            <mask
              id="cw"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cw)">
              <path
                fill="#B22224"
                d="M19.052 25.581a.113.113 0 0 1-.127-.097.11.11 0 0 1 .101-.121.113.113 0 0 1 .126.097.111.111 0 0 1-.1.121Z"
              />
            </g>
            <mask
              id="cx"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cx)">
              <path
                fill="#B22224"
                d="M19.537 25.026a.103.103 0 0 1-.115-.088.1.1 0 0 1 .092-.11.103.103 0 0 1 .115.088.101.101 0 0 1-.092.11Z"
              />
            </g>
            <mask
              id="cy"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cy)">
              <path
                fill="#B22224"
                d="M20.113 24.562a.093.093 0 0 1-.104-.08.09.09 0 0 1 .083-.098.093.093 0 0 1 .103.08.09.09 0 0 1-.082.098Z"
              />
            </g>
            <mask
              id="cz"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cz)">
              <path
                fill="#B22224"
                d="M20.762 24.2a.082.082 0 0 1-.092-.071.08.08 0 0 1 .074-.088.082.082 0 0 1 .091.07.08.08 0 0 1-.073.088Z"
              />
            </g>
            <mask
              id="cA"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cA)">
              <path
                fill="#B22224"
                d="M22.2 23.825a.062.062 0 0 1-.068-.053.06.06 0 0 1 .055-.066.062.062 0 0 1 .069.053.06.06 0 0 1-.055.066Z"
              />
            </g>
            <mask
              id="cB"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cB)">
              <path
                fill="#B22224"
                d="M22.946 23.824a.051.051 0 0 1-.057-.044.05.05 0 0 1 .046-.055.051.051 0 0 1 .057.044.05.05 0 0 1-.046.055Z"
              />
            </g>
            <mask
              id="cC"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cC)">
              <path
                fill="#B22224"
                d="M23.678 23.947a.041.041 0 0 1-.045-.035.04.04 0 0 1 .036-.044.041.041 0 0 1 .046.035.04.04 0 0 1-.037.044Z"
              />
            </g>
            <mask
              id="cD"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cD)">
              <path
                fill="#B22224"
                d="M24.376 24.19a.03.03 0 0 1-.034-.027.03.03 0 0 1 .027-.033.03.03 0 0 1 .035.027.03.03 0 0 1-.028.033Z"
              />
            </g>
            <mask
              id="cE"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cE)">
              <path
                fill="#B22224"
                d="M25.017 24.546a.02.02 0 0 1-.023-.018.02.02 0 0 1 .019-.021.02.02 0 0 1 .022.017.02.02 0 0 1-.018.022Z"
              />
            </g>
            <mask
              id="cF"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cF)">
              <path
                fill="#B22224"
                d="M25.582 25.005a.01.01 0 0 1-.011-.009.01.01 0 0 1 .009-.01c.006-.002.01.002.011.008a.01.01 0 0 1-.009.01Z"
              />
            </g>
            <mask
              id="cG"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cG)">
              <path
                fill="#B22224"
                d="M18.94 24.963a.134.134 0 0 1-.113-.154.138.138 0 0 1 .16-.109.134.134 0 0 1 .113.154.138.138 0 0 1-.16.109Z"
              />
            </g>
            <mask
              id="cH"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cH)">
              <path
                fill="#B22224"
                d="M19.545 24.403a.122.122 0 0 1-.104-.14.126.126 0 0 1 .147-.1c.069.011.115.074.104.14a.126.126 0 0 1-.147.1Z"
              />
            </g>
            <mask
              id="cI"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cI)">
              <path
                fill="#B22224"
                d="M20.24 23.954a.112.112 0 0 1-.094-.128c.01-.06.07-.101.133-.09.063.01.105.067.094.127a.115.115 0 0 1-.133.091Z"
              />
            </g>
            <mask
              id="cJ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cJ)">
              <path
                fill="#B22224"
                d="M21.811 23.432a.09.09 0 0 1-.075-.103.092.092 0 0 1 .107-.072.09.09 0 0 1 .075.102.092.092 0 0 1-.107.073Z"
              />
            </g>
            <mask
              id="cK"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cK)">
              <path
                fill="#B22224"
                d="M22.642 23.374a.078.078 0 0 1-.066-.09.08.08 0 0 1 .093-.063.078.078 0 0 1 .066.09.08.08 0 0 1-.093.063Z"
              />
            </g>
            <mask
              id="cL"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cL)">
              <path
                fill="#B22224"
                d="M21.049 23.666a.078.078 0 0 1-.066-.09.08.08 0 0 1 .093-.063.078.078 0 0 1 .066.09.08.08 0 0 1-.093.063Z"
              />
            </g>
            <mask
              id="cM"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cM)">
              <path
                fill="#B22224"
                d="M23.468 23.456a.067.067 0 0 1-.057-.077.069.069 0 0 1 .08-.054c.037.006.063.04.056.076a.069.069 0 0 1-.08.055Z"
              />
            </g>
            <mask
              id="cN"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cN)">
              <path
                fill="#B22224"
                d="M24.264 23.674a.056.056 0 0 1-.047-.064.057.057 0 0 1 .066-.045.056.056 0 0 1 .047.064.057.057 0 0 1-.066.045Z"
              />
            </g>
            <mask
              id="cO"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cO)">
              <path
                fill="#B22224"
                d="M25.007 24.022a.045.045 0 0 1-.038-.052.046.046 0 0 1 .054-.036.045.045 0 0 1 .037.051.046.046 0 0 1-.053.037Z"
              />
            </g>
            <mask
              id="cP"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cP)">
              <path
                fill="#B22224"
                d="M25.675 24.487a.033.033 0 0 1-.028-.039.034.034 0 0 1 .04-.027c.018.003.03.02.028.039a.034.034 0 0 1-.04.027Z"
              />
            </g>
            <mask
              id="cQ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cQ)">
              <path
                fill="#B22224"
                d="M26.247 25.056a.022.022 0 0 1-.02-.025.023.023 0 0 1 .027-.018c.013.002.021.013.019.025a.023.023 0 0 1-.026.018Z"
              />
            </g>
            <mask
              id="cR"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cR)">
              <path
                fill="#B22224"
                d="M26.704 25.713a.011.011 0 0 1-.01-.013.012.012 0 0 1 .014-.01c.006.002.01.008.009.014a.011.011 0 0 1-.013.009Z"
              />
            </g>
            <mask
              id="cS"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cS)">
              <path
                fill="#B22224"
                d="M18.885 24.26a.158.158 0 0 1-.078-.214.17.17 0 0 1 .223-.075.158.158 0 0 1 .078.214.17.17 0 0 1-.223.075Z"
              />
            </g>
            <mask
              id="cT"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cT)">
              <path
                fill="#B22224"
                d="M19.623 23.71a.146.146 0 0 1-.072-.198.156.156 0 0 1 .206-.069.145.145 0 0 1 .071.198.156.156 0 0 1-.205.069Z"
              />
            </g>
            <mask
              id="cU"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cU)">
              <path
                fill="#B22224"
                d="M20.447 23.29a.133.133 0 0 1-.066-.18.143.143 0 0 1 .188-.064c.07.033.1.114.066.181a.143.143 0 0 1-.188.064Z"
              />
            </g>
            <mask
              id="cV"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cV)">
              <path
                fill="#B22224"
                d="M21.333 23.016a.121.121 0 0 1-.06-.165.13.13 0 0 1 .17-.057c.064.03.091.103.06.164a.13.13 0 0 1-.17.058Z"
              />
            </g>
            <mask
              id="cW"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cW)">
              <path
                fill="#B22224"
                d="M24.082 23.104a.085.085 0 0 1-.042-.115.091.091 0 0 1 .12-.04c.044.02.063.072.042.114a.091.091 0 0 1-.12.04Z"
              />
            </g>
            <mask
              id="cX"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cX)">
              <path
                fill="#B22224"
                d="M24.938 23.435a.073.073 0 0 1-.036-.099.078.078 0 0 1 .103-.034.073.073 0 0 1 .036.098.078.078 0 0 1-.103.035Z"
              />
            </g>
            <mask
              id="cY"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cY)">
              <path
                fill="#B22224"
                d="M25.72 23.903a.06.06 0 0 1-.03-.082.065.065 0 0 1 .085-.03.06.06 0 0 1 .03.083.065.065 0 0 1-.086.029Z"
              />
            </g>
            <mask
              id="cZ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#cZ)">
              <path
                fill="#B22224"
                d="M26.402 24.493a.048.048 0 0 1-.023-.066.052.052 0 0 1 .068-.023.048.048 0 0 1 .024.066.052.052 0 0 1-.069.023Z"
              />
            </g>
            <mask
              id="da"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#da)">
              <path
                fill="#B22224"
                d="M26.968 25.187a.036.036 0 0 1-.018-.05.04.04 0 0 1 .051-.017c.019.009.027.031.018.05a.04.04 0 0 1-.051.017Z"
              />
            </g>
            <mask
              id="db"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#db)">
              <path
                fill="#B22224"
                d="M27.397 25.963a.024.024 0 0 1-.012-.033.026.026 0 0 1 .034-.011c.013.006.018.02.012.033a.026.026 0 0 1-.034.011Z"
              />
            </g>
            <mask
              id="dc"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dc)">
              <path
                fill="#B22224"
                d="M27.676 26.799a.012.012 0 0 1-.006-.016.013.013 0 0 1 .017-.006c.007.003.01.01.006.016a.013.013 0 0 1-.017.006Z"
              />
            </g>
            <mask
              id="dd"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dd)">
              <path
                fill="#B22224"
                d="M18.904 23.466a.187.187 0 0 1-.016-.27c.073-.08.2-.087.281-.016.082.07.09.192.017.27a.205.205 0 0 1-.282.016Z"
              />
            </g>
            <mask
              id="de"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#de)">
              <path
                fill="#B22224"
                d="M19.788 22.943a.174.174 0 0 1-.015-.251.19.19 0 0 1 .262-.015.174.174 0 0 1 .014.252.19.19 0 0 1-.26.014Z"
              />
            </g>
            <mask
              id="df"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#df)">
              <path
                fill="#B22224"
                d="M20.751 22.573a.16.16 0 0 1-.014-.232.175.175 0 0 1 .241-.013.16.16 0 0 1 .014.232.175.175 0 0 1-.24.013Z"
              />
            </g>
            <mask
              id="dg"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dg)">
              <path
                fill="#B22224"
                d="M21.765 22.369a.147.147 0 0 1-.013-.213.16.16 0 0 1 .22-.012c.066.055.071.15.014.212a.16.16 0 0 1-.221.013Z"
              />
            </g>
            <mask
              id="dh"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dh)">
              <path
                fill="#B22224"
                d="M23.818 22.474a.12.12 0 0 1-.01-.174.131.131 0 0 1 .18-.01.12.12 0 0 1 .01.174.132.132 0 0 1-.18.01Z"
              />
            </g>
            <mask
              id="di"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#di)">
              <path
                fill="#B22224"
                d="M25.706 23.24a.093.093 0 0 1-.008-.135c.037-.04.1-.043.141-.008a.093.093 0 0 1 .008.135.102.102 0 0 1-.14.008Z"
              />
            </g>
            <mask
              id="dj"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dj)">
              <path
                fill="#B22224"
                d="M26.515 23.846a.08.08 0 0 1-.006-.116.088.088 0 0 1 .12-.007.08.08 0 0 1 .007.116.088.088 0 0 1-.12.007Z"
              />
            </g>
            <mask
              id="dk"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dk)">
              <path
                fill="#B22224"
                d="M27.2 24.576a.067.067 0 0 1-.005-.096.073.073 0 0 1 .1-.006c.03.025.032.068.006.096a.073.073 0 0 1-.1.006Z"
              />
            </g>
            <mask
              id="dl"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dl)">
              <path
                fill="#B22224"
                d="M27.743 25.408a.053.053 0 0 1-.005-.078.059.059 0 0 1 .08-.004c.024.02.026.055.005.077a.058.058 0 0 1-.08.005Z"
              />
            </g>
            <mask
              id="dm"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dm)">
              <path
                fill="#B22224"
                d="M28.126 26.315a.04.04 0 0 1-.004-.058.044.044 0 0 1 .06-.003.04.04 0 0 1 .004.058.044.044 0 0 1-.06.003Z"
              />
            </g>
            <mask
              id="dn"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dn)">
              <path
                fill="#B22224"
                d="M28.337 27.271a.027.027 0 0 1-.002-.038.03.03 0 0 1 .04-.003c.011.01.012.028.002.039a.03.03 0 0 1-.04.002Z"
              />
            </g>
            <mask
              id="do"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#do)">
              <path
                fill="#B22224"
                d="M28.37 28.246a.013.013 0 0 1-.002-.019.015.015 0 0 1 .02-.001.013.013 0 0 1 .002.02.015.015 0 0 1-.02 0Z"
              />
            </g>
            <mask
              id="dp"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dp)">
              <path
                fill="#B22224"
                d="M18.757 22.381a.223.223 0 0 1 .074-.315.243.243 0 0 1 .327.071.223.223 0 0 1-.074.315.243.243 0 0 1-.327-.07Z"
              />
            </g>
            <mask
              id="dq"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dq)">
              <path
                fill="#B22224"
                d="M20.06 22.101a.208.208 0 0 1 .07-.294.227.227 0 0 1 .305.066c.066.1.035.232-.069.294a.227.227 0 0 1-.305-.066Z"
              />
            </g>
            <mask
              id="dr"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dr)">
              <path
                fill="#B22224"
                d="M21.172 21.803a.194.194 0 0 1 .063-.273.21.21 0 0 1 .284.061.193.193 0 0 1-.064.273.21.21 0 0 1-.283-.061Z"
              />
            </g>
            <mask
              id="ds"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ds)">
              <path
                fill="#B22224"
                d="M22.318 21.692a.179.179 0 0 1 .059-.252.194.194 0 0 1 .262.056.179.179 0 0 1-.06.253.194.194 0 0 1-.261-.057Z"
              />
            </g>
            <mask
              id="dt"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dt)">
              <path
                fill="#B22224"
                d="M23.465 21.772a.164.164 0 0 1 .054-.231.178.178 0 0 1 .24.052.164.164 0 0 1-.054.23.178.178 0 0 1-.24-.051Z"
              />
            </g>
            <mask
              id="du"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#du)">
              <path
                fill="#B22224"
                d="M25.625 22.49a.134.134 0 0 1 .044-.189.146.146 0 0 1 .196.043.134.134 0 0 1-.044.189.146.146 0 0 1-.196-.043Z"
              />
            </g>
            <mask
              id="dv"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dv)">
              <path
                fill="#B22224"
                d="M28.999 25.086a.134.134 0 0 1 .044-.188.146.146 0 0 1 .197.042.134.134 0 0 1-.045.189.146.146 0 0 1-.196-.043Z"
              />
            </g>
            <mask
              id="dw"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dw)">
              <path
                fill="#B22224"
                d="M27.398 23.864a.104.104 0 0 1 .035-.146.113.113 0 0 1 .152.033.104.104 0 0 1-.034.147.113.113 0 0 1-.153-.034Z"
              />
            </g>
            <mask
              id="dx"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dx)">
              <path
                fill="#B22224"
                d="M28.07 24.75a.09.09 0 0 1 .029-.126.097.097 0 0 1 .13.028.09.09 0 0 1-.029.126.097.097 0 0 1-.13-.028Z"
              />
            </g>
            <mask
              id="dy"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dy)">
              <path
                fill="#B22224"
                d="M28.569 25.732a.074.074 0 0 1 .024-.105.08.08 0 0 1 .11.024.074.074 0 0 1-.025.105.081.081 0 0 1-.11-.024Z"
              />
            </g>
            <mask
              id="dz"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dz)">
              <path
                fill="#B22224"
                d="M28.883 26.78a.06.06 0 0 1 .02-.084.065.065 0 0 1 .087.019.06.06 0 0 1-.02.084.065.065 0 0 1-.087-.02Z"
              />
            </g>
            <mask
              id="dA"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dA)">
              <path
                fill="#B22224"
                d="M29.003 27.862a.045.045 0 0 1 .015-.063.049.049 0 0 1 .065.014.045.045 0 0 1-.014.063.048.048 0 0 1-.066-.014Z"
              />
            </g>
            <mask
              id="dB"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dB)">
              <path
                fill="#B22224"
                d="M28.65 29.996a.015.015 0 0 1 .004-.02.016.016 0 0 1 .022.004.015.015 0 0 1-.005.02.016.016 0 0 1-.022-.004Z"
              />
            </g>
            <mask
              id="dC"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dC)">
              <path
                fill="#B22224"
                d="M19.256 21.593a.27.27 0 0 1 .191-.336c.15-.042.306.04.35.184a.27.27 0 0 1-.192.336.283.283 0 0 1-.349-.184Z"
              />
            </g>
            <mask
              id="dD"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dD)">
              <path
                fill="#B22224"
                d="M20.466 21.186a.252.252 0 0 1 .18-.315c.139-.04.285.038.326.172a.252.252 0 0 1-.179.315.265.265 0 0 1-.327-.172Z"
              />
            </g>
            <mask
              id="dE"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dE)">
              <path
                fill="#B22224"
                d="M21.73 20.984a.236.236 0 0 1 .168-.294.248.248 0 0 1 .305.161.236.236 0 0 1-.167.294.248.248 0 0 1-.305-.161Z"
              />
            </g>
            <mask
              id="dF"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dF)">
              <path
                fill="#B22224"
                d="M23.012 20.993a.22.22 0 0 1 .155-.273.23.23 0 0 1 .284.15.219.219 0 0 1-.156.272.23.23 0 0 1-.283-.15Z"
              />
            </g>
            <mask
              id="dG"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dG)">
              <path
                fill="#B22224"
                d="M22.657 22.516a.219.219 0 0 1 .155-.273.23.23 0 0 1 .284.15.219.219 0 0 1-.156.272.23.23 0 0 1-.283-.15Z"
              />
            </g>
            <mask
              id="dH"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dH)">
              <path
                fill="#B22224"
                d="M24.271 21.212a.202.202 0 0 1 .144-.252.212.212 0 0 1 .261.138.202.202 0 0 1-.143.252.212.212 0 0 1-.262-.138Z"
              />
            </g>
            <mask
              id="dI"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dI)">
              <path
                fill="#B22224"
                d="M25.472 21.636a.185.185 0 0 1 .13-.231.195.195 0 0 1 .24.126.185.185 0 0 1-.13.23.195.195 0 0 1-.24-.125Z"
              />
            </g>
            <mask
              id="dJ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dJ)">
              <path
                fill="#B22224"
                d="M24.685 22.321a.185.185 0 0 1 .131-.23.194.194 0 0 1 .24.126.185.185 0 0 1-.131.23.195.195 0 0 1-.24-.126Z"
              />
            </g>
            <mask
              id="dK"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dK)">
              <path
                fill="#B22224"
                d="M28.344 23.972a.185.185 0 0 1 .13-.231.195.195 0 0 1 .24.126.185.185 0 0 1-.13.231.194.194 0 0 1-.24-.126Z"
              />
            </g>
            <mask
              id="dL"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dL)">
              <path
                fill="#B22224"
                d="M26.572 22.684a.185.185 0 0 1 .131-.23.195.195 0 0 1 .24.125.185.185 0 0 1-.13.231.195.195 0 0 1-.24-.126Z"
              />
            </g>
            <mask
              id="dM"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dM)">
              <path
                fill="#B22224"
                d="M27.55 23.04a.151.151 0 0 1 .107-.19.16.16 0 0 1 .196.104.151.151 0 0 1-.107.188.16.16 0 0 1-.197-.103Z"
              />
            </g>
            <mask
              id="dN"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dN)">
              <path
                fill="#B22224"
                d="M29.441 26.173a.1.1 0 0 1 .072-.125.106.106 0 0 1 .13.068.1.1 0 0 1-.07.126.106.106 0 0 1-.132-.069Z"
              />
            </g>
            <mask
              id="dO"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dO)">
              <path
                fill="#B22224"
                d="M29.665 28.581a.067.067 0 0 1 .047-.084.07.07 0 0 1 .087.046.067.067 0 0 1-.047.084.07.07 0 0 1-.087-.046Z"
              />
            </g>
            <mask
              id="dP"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dP)">
              <path
                fill="#B22224"
                d="M21.033 20.204a.307.307 0 0 1 .31-.302c.173 0 .314.133.315.3a.307.307 0 0 1-.31.301.307.307 0 0 1-.315-.299Z"
              />
            </g>
            <mask
              id="dQ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dQ)">
              <path
                fill="#B22224"
                d="M22.455 20.126c-.001-.156.13-.283.291-.284.162 0 .294.125.295.28 0 .156-.13.283-.291.284a.288.288 0 0 1-.295-.28Z"
              />
            </g>
            <mask
              id="dR"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dR)">
              <path
                fill="#B22224"
                d="M23.87 20.283c-.001-.145.12-.264.272-.265.15 0 .274.117.274.262.001.145-.12.264-.271.265a.269.269 0 0 1-.275-.262Z"
              />
            </g>
            <mask
              id="dS"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dS)">
              <path
                fill="#B22224"
                d="M25.235 20.67a.25.25 0 0 1 .253-.246.25.25 0 0 1 .255.243.249.249 0 0 1-.252.246.25.25 0 0 1-.256-.243Z"
              />
            </g>
            <mask
              id="dT"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dT)">
              <path
                fill="#B22224"
                d="M26.51 21.275a.23.23 0 0 1 .234-.226c.13-.001.235.1.236.224a.23.23 0 0 1-.233.227.23.23 0 0 1-.236-.225Z"
              />
            </g>
            <mask
              id="dU"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dU)">
              <path
                fill="#B22224"
                d="M27.658 22.081a.21.21 0 0 1 .214-.207c.118-.001.215.091.216.205a.21.21 0 0 1-.214.208.211.211 0 0 1-.216-.206Z"
              />
            </g>
            <mask
              id="dV"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dV)">
              <path
                fill="#B22224"
                d="M28.641 23.065c0-.104.087-.188.194-.189.108 0 .196.083.197.187a.192.192 0 0 1-.195.189.192.192 0 0 1-.196-.187Z"
              />
            </g>
            <mask
              id="dW"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dW)">
              <path
                fill="#B22224"
                d="M29.43 24.193c0-.094.078-.17.175-.17.097 0 .176.075.177.168 0 .094-.078.17-.175.17a.173.173 0 0 1-.177-.168Z"
              />
            </g>
            <mask
              id="dX"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dX)">
              <path
                fill="#B22224"
                d="M30.008 25.433c0-.082.07-.15.155-.15.087-.001.157.066.158.149 0 .083-.07.15-.156.151a.153.153 0 0 1-.157-.15Z"
              />
            </g>
            <mask
              id="dY"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dY)">
              <path
                fill="#B22224"
                d="M30.454 28.098c0-.062.051-.113.116-.113s.117.05.118.112a.115.115 0 0 1-.117.113.115.115 0 0 1-.117-.112Z"
              />
            </g>
            <mask
              id="dZ"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#dZ)">
              <path
                fill="#B22224"
                d="M29.732 27.224c0-.063.052-.114.117-.114.064 0 .117.05.117.112a.115.115 0 0 1-.116.113.115.115 0 0 1-.118-.111Z"
              />
            </g>
            <mask
              id="ea"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ea)">
              <path
                fill="#B22224"
                d="M21.792 19.171a.371.371 0 0 1 .455-.246c.197.053.31.25.256.438a.371.371 0 0 1-.455.246.354.354 0 0 1-.256-.438Z"
              />
            </g>
            <mask
              id="eb"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#eb)">
              <path
                fill="#B22224"
                d="M23.372 19.245a.35.35 0 0 1 .429-.232c.184.05.292.235.24.412a.35.35 0 0 1-.428.232.333.333 0 0 1-.24-.412Z"
              />
            </g>
            <mask
              id="ec"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ec)">
              <path
                fill="#B22224"
                d="M26.378 20.165a.306.306 0 0 1 .374-.203.291.291 0 0 1 .21.36.306.306 0 0 1-.374.203.291.291 0 0 1-.21-.36Z"
              />
            </g>
            <mask
              id="ed"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ed)">
              <path
                fill="#B22224"
                d="M28.883 22.003a.262.262 0 0 1 .32-.174.25.25 0 0 1 .181.31.262.262 0 0 1-.321.173.25.25 0 0 1-.18-.31Z"
              />
            </g>
            <mask
              id="ee"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ee)">
              <path
                fill="#B22224"
                d="M30.588 24.542a.218.218 0 0 1 .268-.144.208.208 0 0 1 .15.257.218.218 0 0 1-.268.145.208.208 0 0 1-.15-.258Z"
              />
            </g>
            <mask
              id="ef"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ef)">
              <path
                fill="#B22224"
                d="M31.295 27.475a.175.175 0 0 1 .214-.116.166.166 0 0 1 .12.206.175.175 0 0 1-.214.116.166.166 0 0 1-.12-.206Z"
              />
            </g>
            <mask
              id="eg"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#eg)">
              <path
                fill="#B22224"
                d="M31.244 28.981a.153.153 0 0 1 .188-.101c.08.022.127.103.105.18a.153.153 0 0 1-.188.101.145.145 0 0 1-.105-.18Z"
              />
            </g>
            <mask
              id="eh"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#eh)">
              <path
                fill="#B22224"
                d="M36 29.434c.042-.145.2-.23.35-.19.15.042.239.192.196.337a.285.285 0 0 1-.35.19.272.272 0 0 1-.196-.337Z"
              />
            </g>
            <mask
              id="ei"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ei)">
              <path
                fill="#B22224"
                d="M24.513 18.365a.42.42 0 0 1 .564-.129.386.386 0 0 1 .133.543.42.42 0 0 1-.564.129.386.386 0 0 1-.133-.543Z"
              />
            </g>
            <mask
              id="ej"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ej)">
              <path
                fill="#B22224"
                d="M26.33 18.717a.395.395 0 0 1 .53-.121.363.363 0 0 1 .126.51.395.395 0 0 1-.531.122.363.363 0 0 1-.126-.511Z"
              />
            </g>
            <mask
              id="ek"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ek)">
              <path
                fill="#B22224"
                d="M27.742 19.374a.37.37 0 0 1 .497-.113c.17.1.223.315.118.479a.37.37 0 0 1-.498.113.34.34 0 0 1-.117-.48Z"
              />
            </g>
            <mask
              id="el"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#el)">
              <path
                fill="#B22224"
                d="M29.093 20.777a.345.345 0 0 1 .465-.105.318.318 0 0 1 .11.447.345.345 0 0 1-.465.105.318.318 0 0 1-.11-.447Z"
              />
            </g>
            <mask
              id="em"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#em)">
              <path
                fill="#B22224"
                d="M30.26 22.042a.32.32 0 0 1 .431-.098.295.295 0 0 1 .103.415.32.32 0 0 1-.432.098.295.295 0 0 1-.102-.415Z"
              />
            </g>
            <mask
              id="en"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#en)">
              <path
                fill="#B22224"
                d="M31.184 23.48a.296.296 0 0 1 .398-.091c.136.08.178.252.095.383a.296.296 0 0 1-.399.09.273.273 0 0 1-.094-.383Z"
              />
            </g>
            <mask
              id="eo"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#eo)">
              <path
                fill="#B22224"
                d="M31.837 25.045a.271.271 0 0 1 .365-.083.25.25 0 0 1 .086.352.271.271 0 0 1-.364.083.25.25 0 0 1-.087-.352Z"
              />
            </g>
            <mask
              id="ep"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ep)">
              <path
                fill="#B22224"
                d="M32.198 26.694a.247.247 0 0 1 .331-.075c.114.067.149.21.079.319a.247.247 0 0 1-.332.076.227.227 0 0 1-.078-.32Z"
              />
            </g>
            <mask
              id="eq"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#eq)">
              <path
                fill="#B22224"
                d="M32.258 28.372a.222.222 0 0 1 .298-.068c.102.06.134.19.07.287a.222.222 0 0 1-.298.068.204.204 0 0 1-.07-.287Z"
              />
            </g>
            <mask
              id="er"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#er)">
              <path
                fill="#B22224"
                d="M27.847 18.054a.468.468 0 0 1 .644.03c.17.178.156.456-.03.619a.468.468 0 0 1-.644-.03.427.427 0 0 1 .03-.619Z"
              />
            </g>
            <mask
              id="es"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#es)">
              <path
                fill="#B22224"
                d="M29.279 19.377a.44.44 0 0 1 .606.028c.159.168.146.429-.029.582a.44.44 0 0 1-.606-.027.402.402 0 0 1 .029-.583Z"
              />
            </g>
            <mask
              id="et"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#et)">
              <path
                fill="#B22224"
                d="M31.8 22.232a.385.385 0 0 1 .53.024.351.351 0 0 1-.026.51.385.385 0 0 1-.53-.024.352.352 0 0 1 .025-.51Z"
              />
            </g>
            <mask
              id="eu"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#eu)">
              <path
                fill="#B22224"
                d="M33.371 27.6a.303.303 0 0 1 .417.018c.11.116.1.296-.02.401a.303.303 0 0 1-.416-.019.276.276 0 0 1 .02-.4Z"
              />
            </g>
            <mask
              id="ev"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ev)">
              <path
                fill="#B22224"
                d="M33.667 22.169a.455.455 0 0 1 .598.194c.11.213.019.47-.203.576a.455.455 0 0 1-.598-.195.422.422 0 0 1 .203-.575Z"
              />
            </g>
            <mask
              id="ew"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ew)">
              <path
                fill="#B22224"
                d="M34.432 24.942a.455.455 0 0 1 .598.195c.11.212.019.47-.203.575a.455.455 0 0 1-.598-.194.422.422 0 0 1 .203-.576Z"
              />
            </g>
            <mask
              id="ex"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ex)">
              <path
                fill="#B22224"
                d="M34.579 28.729a.364.364 0 0 1 .478.155.338.338 0 0 1-.162.461.364.364 0 0 1-.478-.156.338.338 0 0 1 .162-.46Z"
              />
            </g>
            <mask
              id="ey"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ey)">
              <path
                fill="#B22224"
                d="M33.184 30.938a.485.485 0 0 1 .639.208.45.45 0 0 1-.217.614.485.485 0 0 1-.638-.208.45.45 0 0 1 .216-.614Z"
              />
            </g>
            <mask
              id="ez"
              width={208}
              height={117}
              x={-40}
              y={-30}
              maskUnits="userSpaceOnUse"
              style={{
                maskType: 'luminance',
              }}
            >
              <path fill="#fff" d="M-39.73-30h207.568V86.757H-39.73V-30Z" />
            </mask>
            <g mask="url(#ez)">
              <path
                fill="#B22224"
                d="M35.496 32.296a.562.562 0 0 1 .74.24.522.522 0 0 1-.25.713.562.562 0 0 1-.74-.241.522.522 0 0 1 .25-.712Z"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.162 3H47.92v42H.162z" />
        </clipPath>
      </defs>
    </svg>
  );
}
